var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weed-search"},[_c('page-title'),_c('div',{staticClass:"search"},[_c('div',{staticClass:"count"},[_c('span',[_vm._v("全件数："+_vm._s(_vm.count)+"件")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }